import { InputField } from "components/designV2/inputfield/inputfield";
import React, { useState, useEffect } from "react";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const PercentageInput: React.FC<{
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  title: string;
  info: string;
}> = ({ value, onChange, min, max, title, info }) => {
  const [str, setStr] = useState(value.toString());

  useEffect(() => {
    setStr(value.toString());
  }, [value]);

  const commit = () => {
    const n = normalizeNumber(str);
    const v =
      n == null ? min : Math.min(max, Math.max(min, Math.round(n * 100) / 100));
    setStr(v.toFixed(2));
    onChange(v);
  };

  return (
    <SystemSettingRow
      title={title}
      description={info}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <InputField
            ariaLabel={title}
            value={str}
            type="number"
            size="compact"
            maxLength={6}
            onChange={setStr}
            onBlur={commit}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
